import React from "react";
import { TooltipRenderProps } from "react-joyride";
import { Box, Button, Typography, styled, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import CircleIcon from "@mui/icons-material/Circle";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";

const Container = styled(Box)({
  backgroundColor: "#fff",
  padding: "2rem 1.5rem 1.8rem 1.5rem",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
  maxWidth: "24rem",
  minWidth: "20rem",
  textAlign: "center",
  position: "relative",
});

const ButtonRow = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "1.5rem",
  gap: "1rem",
  flexWrap: "wrap",
});

const StepIndicators = styled(Box)({
  display: "flex",
  justifyContent: "center",
  gap: "0.5rem",
  marginTop: "1.25rem",
  marginBottom: "2.5rem",
});

const StyledButton = styled(Button)({
  marginTop: "1.5rem",
  position: "absolute",
  bottom: "1rem",
  right: "1.5rem",
  backgroundColor: "#8CA895",
  color: "#fff",
  center: "left", 
  fontWeight: 600,
  padding: "0.5rem 1.8rem",
  borderRadius: "8px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#789781",
  },
});

const SkipText = styled(Button)({
  position: "absolute",
  bottom: "1rem",
  left: "1.5rem",
  textTransform: "none",
  fontWeight: 500,
  fontSize: "0.9rem",
  color: "#8CA895",
  background: "none",
  boxShadow: "none",
  minWidth: "unset",
  padding: 0,
  "&:hover": {
    background: "none",
    textDecoration: "underline",
  },
});

interface CustomTooltipProps extends TooltipRenderProps {
  stepIndex: number;
  setStepIndex: (index: number) => void;
  onManualFinish: () => void;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  step,
  index,
  size,
  backProps,
  closeProps,
  onManualFinish,
  primaryProps,
  stepIndex,
  setStepIndex
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Typography variant="subtitle1" fontWeight={600}>
        {step.content}
      </Typography>


      <StepIndicators>
        {Array.from({ length: size }).map((_, i) => (
          <IconButton
            key={i}
            size="small"
            onClick={() => setStepIndex(i)}
            sx={{
              padding: 0,
              color: i === index ? "#8CA895" : "#ccc",
              transition: "all 0.3s ease",
            }}
          >
            {i === index ? (
              <CircleIcon fontSize="small" />
            ) : (
              <CircleOutlinedIcon fontSize="small" />
            )}
          </IconButton>
        ))}
      </StepIndicators>
      <ButtonRow>    
          {index + 1 === size && (<StyledButton onClick={onManualFinish}>
            {t("Fertig")}
          </StyledButton>)}
           
      <SkipText onClick={onManualFinish}>
        {t("Überspringen")}
      </SkipText>
      </ButtonRow>
    </Container>
  );
};

export default CustomTooltip;
